import { NAME_CONTENT_AGREEMENT, NAME_SHIPPING_INFO, NAME_PERSONAL_INFO, NAME_PRODUCTS, NAME_NETWORKS, NAME_TASKS } from './proposal-steps';
import { MAX_PRICE_EXCEEDED, MAX_PRODUCTS_EXCEEDED, MISSING_PHONE_NUMBER, MISSING_REQUIRED_TASKS, MISSING_REQUIRED_NETWORKS, NO_PRODUCTS_SELECTED, NO_TASKS_SELECTED, NO_SHIPPING_ADDRESS, NO_TERMS_AGREEMENT, OUT_OF_STOCK } from './proposal-step-error-codes';
export const STEP_ERROR_MESSAGES = {
    [NAME_NETWORKS]: {
        [MISSING_REQUIRED_NETWORKS]: 'Please connect the required social networks'
    },
    [NAME_PERSONAL_INFO]: {
        [MISSING_PHONE_NUMBER]: 'Please provide the following information'
    },
    [NAME_PRODUCTS]: {
        [NO_PRODUCTS_SELECTED]: 'Please select your product(s)',
        [OUT_OF_STOCK]: 'Some product selections are out of stock',
        [MAX_PRODUCTS_EXCEEDED]: 'You have exceeded the product quantity limit. Please remove 1 or more products.',
        [MAX_PRICE_EXCEEDED]: 'You have exceeded the product price limit. Please change your product selection.'
    },
    [NAME_SHIPPING_INFO]: {
        [NO_SHIPPING_ADDRESS]: 'Please provide your shipping address'
    },
    [NAME_TASKS]: {
        [MISSING_REQUIRED_TASKS]: 'Please review the tasks',
        [NO_TASKS_SELECTED]: 'Please select at least one task'
    },
    [NAME_CONTENT_AGREEMENT]: {
        [NO_TERMS_AGREEMENT]: 'Please agree to our Terms and Privacy Policy'
    }
};
